import React from "react";
import Loader from "react-loader-spinner";
import { CRow, CCard, CCardBody } from "@coreui/react";

const LoadingImg = (props) => {
  return (
    (props.type === "card") ?
      <CRow className="px-3 ">
        <CCard className="shadow ">
          <CCardBody className="min_h_300">
            <Loader
              style={{ position: 'absolute', top: '40%', left: '50%' }}
              type="Bars"
              color="#3c4b64"
              height={50}
              width={50}
            />
          </CCardBody>
        </CCard>
      </CRow>
      :
      <Loader
        style={{ position: 'absolute', top: '50%', left: '50%' }}
        type="Bars"
        color="#3c4b64"
        height={50}
        width={50}
      />
  )
}

export default LoadingImg;